"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replayReducer = replayReducer;
var _types = require("./types");
var initialState = {
  playingReplay: false
};
function replayReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    // ONLY GETS FIRED WHEN LOGGED IN WATCHING OWN REPLAY
    case _types.REPLAY_ROUND:
      {
        return Object.assign({}, state, {
          showChevrons: false,
          showRoundId: true,
          showIcon: true,
          mode: _types.ReplayMode.Replay
        });
      }
    case _types.REPLAY_ROUND_START:
      {
        return Object.assign({}, state, {
          playingReplay: true,
          roundId: action.payload.roundId,
          previousBet: action.payload.bet
        });
      }
    case _types.REPLAY_ROUND_END:
      {
        return Object.assign({}, state, {
          playingReplay: false,
          roundId: undefined,
          previousBet: undefined,
          showChevrons: false,
          showRoundId: false,
          showIcon: false,
          mode: undefined
        });
      }
    // ONLY WHEN LAUNCHING REPLAY.
    case _types.REPLAY_ROUND_LAUNCH:
      {
        var resp = action.payload;
        return Object.assign({}, state, {
          me: resp.me,
          played: resp.played,
          where: resp.where,
          playingReplay: true,
          replayLaunch: true,
          showChevrons: false,
          coinsBet: resp.coinsBet,
          coinsWin: resp.coinsWon,
          win: resp.win,
          coinsWinXBet: resp.coinsWon / resp.coinsBet,
          roundId: resp.roundId,
          mode: _types.ReplayMode.ReplayLaunch
        });
      }
    // ONLY IN DEMO MODE
    case _types.REPLAY_ROUND_DEMO:
      {
        var resp = action.payload;
        return Object.assign({}, state, {
          mode: _types.ReplayMode.Demo
        });
      }
    default:
      return state;
  }
}
//# sourceMappingURL=reducer.js.map